 // ***************************************************
// 创建一个表示当前本地日期和时间的 Date 对象
const currentDate = new Date();
// 1 天的毫秒数为 24 * 60 * 60 * 1000
const threeDaysLater = new Date(currentDate.getTime() + (3 * 24 * 60 * 60 * 1000));
const fiveDaysLater = new Date(currentDate.getTime() + (5 * 24 * 60 * 60 * 1000));
const sevenDaysLater = new Date(currentDate.getTime() + (7 * 24 * 60 * 60 * 1000));
const tenDaysLater = new Date(currentDate.getTime() + (10 * 24 * 60 * 60 * 1000));
const options = {
    // year: 'numeric',
    month: 'short',
    day: 'numeric'
};

// 使用 Intl.DateTimeFormat 进行日期格式化
const formatter = new Intl.DateTimeFormat('en-US', options);
// 对日期进行格式化
const threeFormattedDate = formatter.format(threeDaysLater);
const fiveFormattedDate = formatter.format(fiveDaysLater);
const sevenFormattedDate = formatter.format(sevenDaysLater);
const tenFormattedDate = formatter.format(tenDaysLater);
// ***************************************************




let abbreviation = '';
let fullName = '';
// 获取国家ip
function getUserCountry() {
  fetch('https://ipinfo.io/json')
    .then(response => response.json())
    .then(data => {
      abbreviation = data.country

      // 如果US则展示USA
      if(abbreviation == 'US'){
        fullName = 'USA'
        $(".buyMe_early_dates").text(threeFormattedDate)
        $(".buyMe_late_dates").text(fiveFormattedDate)
      }else{
        // 如果匹配到其他国家则展示对应国家全称 否则 展示USA
        let isFullName = convertAbbreviationToFullName(abbreviation);
        if(isFullName=="false"){
          fullName = 'USA'
          $(".buyMe_early_dates").text(threeFormattedDate)
          $(".buyMe_late_dates").text(fiveFormattedDate)
        }else{
          fullName = isFullName
          $(".buyMe_early_dates").text(sevenFormattedDate)
          $(".buyMe_late_dates").text(tenFormattedDate)
        }
      }
      if($(".buyMe")){
        $(".buyMe-left h6 span").text(fullName)
      }
    })
    .catch(error => console.error('Error:', error));
}
getUserCountry(); // 调用函数




function getBuyMePrice(){
  setTimeout(() => {
    let buyMe_price = $(".product-wrap .product-details .product-price .cs_money").text()
    let buyMe_original_price = $(".product-wrap .product-details .product-price .cs_original_price").text()
    let isDiscount = $(".buyMe-right .isDiscount").text()
    if(isDiscount && isDiscount!=''){

      function formatNumber(num) {
          return num.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
          });
      }
      let newDiscountPrice = formatNumber(Number(buyMe_price.replace("$","").replaceAll(",",""))- isDiscount)
      $(".buyMe .price__current .money").text("$"+newDiscountPrice)
      $(".buyMe .price__current .original_price").text(buyMe_price)
      
    }else{
      $(".buyMe .price__current .money").text(buyMe_price)
      if(buyMe_original_price && buyMe_original_price!=''){
        $(".buyMe .price__current .original_price").text(buyMe_original_price)
      }
      
    }
  }, 500);
}


$(function(){
  getBuyMePrice()
  $("#variant-tiles .variant-tile").click(function(){
    getBuyMePrice()
  })
})


// 首屏不显示，下滑显示 start
 let elementTopfixed = $('.product_livechat').offset().top
   $(window).on('scroll', function() {
      var windowTop = $(window).scrollTop(); 
      if (window.screen.width > 1024) {
        if(windowTop >= elementTopfixed+80){
          $(".buyMe").show()
        }
        if(windowTop < elementTopfixed+80){
            $(".buyMe").hide()
        }
      }else{
        if(windowTop >= elementTopfixed+120){
          $(".buyMe").show()
        }
        if(windowTop < elementTopfixed+120){
            $(".buyMe").hide()
        }
      }
  });
// end


if(localStorage.getItem('buyMeCart')){
  localStorage.removeItem('buyMeCart');
}
// buynow 点击
$(".buyMe .atc-button").click(function(){
  localStorage.setItem('buyMeCart', 'true');
  $(".product-form-add-to-cart input.add-to-cart-button").click()
})